export const SET_HEADER = "[HEADER] SET HEADER";
export const SEARCH_FIELD = "[HEADER] SEARCH TEXT CHANGE";
export const SHOW_SEARCH = "[HEADER] SET SHOW SEARCH";
export const SET_SEARCH_LABEL = "[HEADER] SET SEARCH LABEL";
export const SET_SEARCH_FILTER = "[HEADER] SET SEARCH FILTER";
